var React = require('react');

function SVGIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","d":"M19.2555 10.6C17.4055 8.99 15.0055 8 12.3555 8C7.70551 8 3.77551 11.03 2.39551 15.22L4.75551 16C5.80551 12.81 8.80551 10.5 12.3555 10.5C14.3055 10.5 16.0855 11.22 17.4755 12.38L13.8555 16H22.8555V7L19.2555 10.6Z"}));
}

SVGIcon.defaultProps = {"viewBox":"0 0 25 24"};

module.exports = SVGIcon;

SVGIcon.default = SVGIcon;
